import { render, staticRenderFns } from "./SeedDetails.vue?vue&type=template&id=4735dfc4&scoped=true&"
import script from "./SeedDetails.vue?vue&type=script&lang=js&"
export * from "./SeedDetails.vue?vue&type=script&lang=js&"
import style0 from "./SeedDetails.vue?vue&type=style&index=0&id=4735dfc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4735dfc4",
  null
  
)

export default component.exports